"use strict";

import ItemView from "/js/interaction-views/item-view.js";
import MultipleChoiceItemContentView from "/js/interaction-views/multiple-choice-item-content-view.js";

/**
 * A single step in the multiple choice interaction.
 */
export default class MultipleChoiceItemView extends ItemView {

  // TODO: how to handle it where content is scrollable? ask.

  makeContentView(questionObject, index, numItems) {
    return new MultipleChoiceItemContentView(questionObject, index, numItems);
  }
}
